/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-30 13:58:11
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-04 10:08:58
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/slice/common.ts
 */
import { createSelector } from '@reduxjs/toolkit';
import { EnumReducers as parentEnumReducers } from 'src/store';
import { getStateTarget as getTarget } from 'src/tools/helper';
import {
  getLoaded as _getLoaded,
  getState as _getState,
  //getHasModified as _getHasModified,
  getCollapseStatus,
} from 'src/tools/selectors/salesChannel';

// import { NEW } from 'src/tools/constant';
// import { useSelector } from 'react-redux';
import { generateCollapseOpen } from 'src/constrains/SalesChannelPreviewPageComponents/tools';
import { hierarchyNameGenerator } from 'src/pages/SalesChannelCategory/PagesCategory/tools';
import { assData } from 'src/tools/helper';

const categoryReducer = (reducers) => {
  return [parentEnumReducers.salesChannelCategory, ...reducers];
};

const reducerTarget = (state, reducers) => {
  return getTarget(state, categoryReducer(reducers));
};

const getAllCollapse = (reducer) => {
  return createSelector(
    (state: any) => reducerTarget(state, [reducer, 'collapseOpen']),
    (open) => {
      return open;
    },
  );
};

const getCollapse = (reducer, id) => {
  return getCollapseStatus(categoryReducer([reducer]), id);
};

const getState = (reducer) => {
  return _getState(categoryReducer([reducer]));
};

const getIsSearching = (reducer) => {
  return createSelector(
    (state: any) => reducerTarget(state, [reducer, 'search']),
    (search) => {
      return (search || []).length > 0;
    },
  );
};

const getSearch = (reducer) => {
  return createSelector(
    (state: any) => reducerTarget(state, [reducer, 'search']),
    (search) => {
      return search || [];
    },
  );
};

const getData = (reducer, id) => {
  return createSelector(
    (state: any) => reducerTarget(state, [reducer, 'dataSet']),
    (data) => {
      const re = (data || {})[id];
      return re;
    },
  );
};

const getOrder = (reducer) => {
  return createSelector(
    (state: any) => reducerTarget(state, [reducer, 'order']),
    (order) => {
      return order || {};
    },
  );
};

const getRootUuid = (reducer) => {
  return createSelector(
    (state: any) => reducerTarget(state, [reducer, 'rootUuid']),
    (rootUuid) => {
      return rootUuid;
    },
  );
};

const getRequestSearch = (reducer) => {
  return createSelector(
    (state: any) => reducerTarget(state, [reducer, 'search']),
    //  {

    //},
    (search) => {
      return search.map((i) => i.value);
    },
  );
};

const getLoaded = (reducer) => {
  return _getLoaded(categoryReducer([reducer]));
};

const getMoveList = (reducer, self) => {
  return createSelector(
    (state: any) => reducerTarget(state, [reducer, 'allNodesWithOrder']),
    (state: any) => reducerTarget(state, [reducer, 'dataSet']),
    (allNodesWithOrder, dataSet) => {
      const _allNodesWithOrder = allNodesWithOrder.filter((i) => i !== self);
      return _allNodesWithOrder.reduce((pre, now) => {
        const item = dataSet[now];

        if (item) {
          const { uuid, name, path = [] } = item;
          const suffix = hierarchyNameGenerator('', path);
          return [
            ...pre,
            {
              value: uuid,
              label: name,
              suffix,
            },
          ];
        }
        return pre;
      }, []);
      //return { allNodesWithOrder, dataSet };
    },
  );
};

// const getHasModified = (reducer) => {
//   return _getHasModified(categoryReducer([reducer]));
// };

// const getLastModified = (reducer) => {
//   return _getLastModified(categoryReducer([reducer]));
// };

const willUnmount = ({ state, defaultState }) => {
  if (state.timeoutRef) {
    state.timeoutRef.forEach((i) => {
      try {
        clearTimeout(i);
      } catch (e) {
        console.warn(e);
      }
    });
  }
  assData(state, defaultState);
};

const getUuid = (reducer) => {
  return createSelector(
    (state: any) => reducerTarget(state, [reducer, 'uuid']),
    (state: any) => reducerTarget(state, [reducer, 'salesChannelUuid']),
    (uuid, salesChannelUuid) => {
      return { uuid: uuid || null, salesChannelUuid: salesChannelUuid || null };
    },
  );
};

export {
  generateCollapseOpen,
  getAllCollapse,
  getCollapse,
  getData,
  getIsSearching,
  getLoaded,
  getMoveList,
  getOrder,
  getRequestSearch,
  getRootUuid,
  getSearch,
  getState,
  //getHasModified,
  getUuid,
  reducerTarget,
  willUnmount,
};
